import { RouteComponentProps } from "../../../models/RouteComponent";
import useApiService from "../../../hooks/useApiService";
import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { CompanyDetails, InductionRecord, Slide } from "../../../models/DSF/Induction";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { SiteInductionInterface } from "../../../models/site-induction.interface";
import { Typography } from "@mui/joy";
import { Button } from "primereact/button";
import { ClientRecord } from "../../../models/ClientInfo";
import "./styles.scss";
import { useNavigate } from "react-router-dom";
import { TabPanel, TabView } from "primereact/tabview";
import SiteInductionPagesView from "./Site-Induction-pages-View";
import SiteInductionAttendanceView from "./Site-Induction-attendance-View";

function SiteInductionView(props: RouteComponentProps) {
  const { session } = props;
  const navigate = useNavigate();
  const [slideCompany, setSlideCompany] = useState<CompanyDetails>();
  const [inductionData, setInductionData] = useState<SiteInductionInterface[]>([]);
  const [selectedSlide, setSelectedSlide] = useState<Slide | null>(null);
  const [paginationParams, _] = useState({
    first: 0,
    rows: 10,
    page: 0,
  });
  const { loading, error } = useApiService<InductionRecord>({
    method: "GET",
    url: "site-induction",
    apiName: "open",
    params: {
      limit: paginationParams.rows,
      page: paginationParams.page,
      clientId: props.session.client_id,
      siteId: props.session.site_id,
    },
    onSuccess: data => {
      setSlideCompany(data.companyDetails);
    },
  });

  // TODO: this is a hack until we get the core endpoint that returns all the correct data
  const { loading: siteInductionLoading, error: siteInductionError } = useApiService<
    SiteInductionInterface[]
  >({
    method: "GET",
    url: "induction-page",
    apiName: "core",
    params: {
      limit: paginationParams.rows,
      page: paginationParams.page,
      clientId: props.session.client_id,
      siteId: props.session.site_id,
    },
    onSuccess: data => {
      setInductionData(data);
    },
  });

  const {
    data: client,
    error: clientError,
    loading: clientLoading,
  } = useApiService<ClientRecord>({
    url: `client/${session.client_id}`,
    method: "GET",
    apiName: "core",
  });

  useEffect(() => {
    props.setGlobalLoader(loading || siteInductionLoading || clientLoading);
  }, [loading, siteInductionLoading, clientLoading, props]);

  const renderSlide = (slide: Slide) => {
    return (
      <div className={"slide-carousel"}>
        <div className={"slide-header"}>
          <img src={"/DSF_Logo-Low-trimmed2.ico"} alt={"DSF logo"} />
          <div>
            <Typography level="h3" component="h2">
              {slideCompany?.company_name}
            </Typography>

            <Typography level="h4" component="h2">
              Site: {slideCompany?.site_name}
            </Typography>
            <Typography level={"body-lg"} component={"h3"}>
              Title: {slide.title}
            </Typography>
          </div>
          {client ? <img src={client.photo} alt={client.name} /> : <div />}
        </div>
        <div className={"slide-content"}>
          <div>
            <div className={"slide-photo-container"}>
              <img
                className={"slide-photo"}
                src={slide.photo || "https://ionicframework.com/docs/img/demos/thumbnail.svg"}
                alt={slide.title}
                onError={e => {
                  e.currentTarget.src = "https://ionicframework.com/docs/img/demos/thumbnail.svg";
                }}
              />
            </div>
            <div className={"slide-body"} dangerouslySetInnerHTML={{ __html: slide.body }} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Typography level="h2" component="h1">
        Induction
      </Typography>

      <TabView>
        <TabPanel header="Induction">
          <SiteInductionPagesView {...props} />
        </TabPanel>
        <TabPanel header="Attendance">
          <SiteInductionAttendanceView {...props} />
        </TabPanel>
      </TabView>
    </>
  );
}

export default SiteInductionView;
